module.exports = __webpack_public_path__ + "img/excavation.26f03a15.jpg";